module.exports = __webpack_public_path__ + "static/img/table_tennis.4612219.jpg";